import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { MapPin, Phone, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const [content, setContent] = useState({});

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/content`);
      const contentMap = {};
      response.data.forEach(item => {
        contentMap[item.section_key] = item.content;
      });
      setContent(contentMap);
    } catch (error) {
      console.error('Error fetching content:', error);
    }
  };

  return (
    <footer className="bg-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="bg-white p-3 rounded-xl inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_c19329c1-9bab-43aa-9723-765360d28c48/artifacts/deynhimw_indweller%20stay%20logo%20final.png" 
                alt="INDWELLER STAY Logo" 
                className="h-10"
              />
            </div>
            <p className="text-gray-400 text-sm font-body">
              {content.footer_tagline || 'Comfortable & Affordable Living for Students and Working Professionals'}
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 font-body text-sm">
              <li><Link to="/about" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/locations" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-locations-link">Locations</Link></li>
              <li><Link to="/properties" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-properties-link">Properties</Link></li>
              <li><Link to="/rules" className="text-gray-400 hover:text-brand-orange transition-colors" data-testid="footer-rules-link">Rules</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 font-body text-sm">
              <li><span className="text-gray-400">{content.footer_service_1 || 'Paying Guest Accommodation'}</span></li>
              <li><span className="text-gray-400">{content.footer_service_2 || 'Home Stay Services'}</span></li>
              <li><span className="text-gray-400">{content.footer_service_3 || 'Fully Furnished Rooms'}</span></li>
              <li><span className="text-gray-400">{content.footer_service_4 || '24/7 Security'}</span></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 font-body text-sm">
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-brand-orange" />
                <a 
                  href={`tel:${(content.contact_person_1_phone || '+919876543210').replace(/\s/g, '')}`}
                  className="text-gray-400 hover:text-brand-orange transition-colors"
                  data-testid="footer-phone-1"
                >
                  {content.contact_person_1_phone || '+91 98765 43210'}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} className="text-brand-orange" />
                <a 
                  href={`tel:${(content.contact_person_2_phone || '+919876543211').replace(/\s/g, '')}`}
                  className="text-gray-400 hover:text-brand-orange transition-colors"
                  data-testid="footer-phone-2"
                >
                  {content.contact_person_2_phone || '+91 98765 43211'}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} className="text-brand-orange" />
                <a 
                  href={`mailto:${content.contact_email || 'info@indwellerstay.com'}`}
                  className="text-gray-400 hover:text-brand-orange transition-colors"
                  data-testid="footer-email"
                >
                  {content.contact_email || 'info@indwellerstay.com'}
                </a>
              </li>
              <li className="flex items-start gap-2 text-gray-400">
                <MapPin size={16} className="text-brand-orange mt-1" />
                <span>{content.footer_address || content.contact_address || 'Mumbai, Maharashtra, India'}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm font-body">
            © {new Date().getFullYear()} INDWELLER STAY. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
